import type { IconData } from '@stacksjs/iconify-core'

export const starCircleRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 24c0 10.77 8.73 19.5 19.5 19.5S43.5 34.77 43.5 24S34.77 4.5 24 4.5S4.5 13.23 4.5 24M24 47.5C11.021 47.5.5 36.979.5 24S11.021.5 24 .5S47.5 11.021 47.5 24S36.979 47.5 24 47.5m-2.592-36.043c1.157-1.987 4.027-1.987 5.185 0l2.457 4.22a2 2 0 0 0 1.305.948l4.773 1.033c2.247.487 3.134 3.217 1.602 4.931l-3.254 3.642a2 2 0 0 0-.498 1.534l.492 4.858c.231 2.288-2.09 3.975-4.195 3.048l-4.468-1.97a2 2 0 0 0-1.613 0l-4.469 1.97c-2.104.927-4.426-.76-4.194-3.048l.491-4.858a2 2 0 0 0-.498-1.534l-3.254-3.642c-1.532-1.714-.645-4.444 1.602-4.93l4.773-1.034a2 2 0 0 0 1.305-.948z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default starCircleRemix
